import { render, staticRenderFns } from "./filter-box.vue?vue&type=template&id=b96edf72&scoped=true"
import script from "./filter-box.vue?vue&type=script&lang=js"
export * from "./filter-box.vue?vue&type=script&lang=js"
import style0 from "./filter-box.vue?vue&type=style&index=0&id=b96edf72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96edf72",
  null
  
)

export default component.exports